
/* eslint-disable react/no-string-refs */
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "components/CustomButtons/Button.js";
import ToastModal from "views/components/ToastModal";
import { IconButton } from "@material-ui/core";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { removeSpecialCharFileName } from "utils/Utils";

const styles = {
  fileUpload: {
    display: "flex",
  },
};

class FileUploadDocumentLinkApi extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
      imagePreviewUrl: props.avatar || "",
      previewUrl: props.avatar || "",
      toast: false,
      toastMessageType: "",
      toastMessage: "",
      uploading: false,
    };

    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.toastUpdate = this.toastUpdate.bind(this);
    this.uploadAndSaveDocument = this.uploadAndSaveDocument.bind(this);
  }

  handleImageChange(e) {
    e.preventDefault();

    const file = e.target.files && e.target.files[0];

    if (!file) return;

    if (file.size > 5000000) {
      this.toastUpdate(
        "Error",
        "Selected file size is more than 5 MB. Please select a file smaller than 5 MB.",
        true
      );
      e.target.value = null;
      return;
    }

    if (
      this.props.supportedMimeType &&
      this.props.supportedMimeType.indexOf(file.type) === -1
    ) {
      this.toastUpdate(
        "Error",
        "Selected file is not supported. Supported file types are " +
          this.props.supportedMimeType.toString(),
        true
      );
      e.target.value = null;
      return;
    }

    const reader = new FileReader();

    reader.onloadend = async () => {
      this.setState({
        file,
        imagePreviewUrl: file.name,
        previewUrl: reader.result,
      });

      await this.uploadAndSaveDocument(file);
    };

    reader.readAsDataURL(file);
  }

  async uploadAndSaveDocument(file) {
    const {
      authToken,
      loanApplicationId,
      documentLinkField,
      sendFile,
    } = this.props;

    if (!file) return;

    if (!loanApplicationId) {
      this.toastUpdate("Error", "Loan application ID is required.", true);
      return;
    }

    if (!documentLinkField) {
      this.toastUpdate("Error", "Document link field is required.", true);
      return;
    }

    this.setState({ uploading: true });

    try {
      // Step 1: Upload the file.
      const formData = new FormData();

      const fileName = removeSpecialCharFileName
        ? removeSpecialCharFileName(file.name)
        : file.name;

      formData.append("file", file, fileName);

      const uploadResponse = await apiHandler({
        url: endpoint.FILE_UPLOAD,
        method: "POST",
        authToken,
        data: formData,
      });

      // Use the uploaded file link returned by the upload API.
      const uploadedPath = uploadResponse?.data?.name;

      if (!uploadedPath) {
        throw new Error("File upload did not return a document link.");
      }

      // Step 2: Save the uploaded link using the dynamic field name.
      const updateResponse = await apiHandler({
        url: endpoint.ADMIN_DOCUMENT_UPDATELINKS,
        method: "POST",
        authToken,
        data: {
          loanApplicationId,
          [documentLinkField]: uploadedPath,
        },
      });

      this.setState({
        file,
        imagePreviewUrl: file.name,
        uploading: false,
      });

      // Notify the parent if required.
      if (sendFile) {
        sendFile(uploadedPath);
      }

      this.toastUpdate(
        "Success",
        updateResponse?.message ||
          "Document uploaded and link saved successfully.",
        true
      );
    } catch (error) {
      this.setState({ uploading: false });

      this.toastUpdate(
        "Error",
        error?.message || "Failed to upload or save the document link.",
        true
      );
    }
  }

  handleSubmit(e) {
    e.preventDefault();
  }

  handleClick() {
    if (!this.state.uploading && this.refs.fileInput) {
      this.refs.fileInput.click();
    }
  }

  handleRemove() {
    if (this.state.uploading) return;

    this.setState({
      file: null,
      imagePreviewUrl: this.props.avatar || "",
      previewUrl: this.props.avatar || "",
    });

    this.refs.fileInput.value = null;

    if (this.props.removeFile) {
      this.props.removeFile();
    }
  }

  toastUpdate(type, message, showToast) {
    this.setState({
      toast: showToast,
      toastMessage: message,
      toastMessageType: type,
    });
  }

  render() {
    const {
      avatar,
      changeButtonProps,
      removeButtonProps,
      name,
      removeButton,
      noPreview,
      buttonClass,
      localClasses,
      icon,
    } = this.props;

    const { file, previewUrl, uploading } = this.state;

    return (
      <>
        <div
          className="fileinput fileUpload text-left"
          style={{ position: "relative",margin:"15px 0 0 15px" }}
        >
          <input
            type="file"
            onChange={this.handleImageChange}
            ref="fileInput"
            disabled={uploading}
            style={{
              opacity: 0,
              position: "absolute",
              left: icon ? "-140px" : 0,
              top: "20px",
              zIndex: -1,
            }}
          />

          <div>
              {previewUrl && !name && !noPreview && (
                file?.type === "application/pdf" ? (
                  <div
                    style={{
                      margin: "10px 0",
                      width: "100%",
                    }}
                  >
                    <Button
                      onClick={() => {
                        const pdfWindow = window.open("", "_blank");
                    
                        if (pdfWindow) {
                          pdfWindow.document.write(`
                            <iframe
                              src="${previewUrl}"
                              style="width:100%;height:100%;border:none"
                            ></iframe>
                          `);
                          pdfWindow.document.close();
                        }
                      }}
                    >
                      Open PDF
                    </Button>
                  </div>
                ) : (
                  <img
                    src={previewUrl}
                    className="picture-src"
                    width="80%"
                    height="200px"
                    alt="Document preview"
                  />
                )
              )}
            </div>
          <div className={buttonClass ? localClasses.container : ""}>
            {file === null ? (
              icon ? (
                <IconButton
                  onClick={this.handleClick}
                  disabled={uploading}
                  style={{
                    color: "blue",
                    marginRight: "8px",
                  }}
                >
                  <AddPhotoAlternateIcon />
                </IconButton>
              ) : (
                <Button
                  onClick={this.handleClick}
                  disabled={uploading}
                  className={
                    buttonClass
                      ? `${localClasses.button2} ${localClasses.nextButton1}`
                      : this.props.classes.nextButton
                  }
                >
                  {uploading
                    ? "Uploading..."
                    : avatar
                    ? "BROWSE"
                    : name || "Upload Form 60"}
                </Button>
              )
            ) : (
              !removeButton && (
                <span className="fileUpload">
                  {!name && (
                    <Button
                      {...changeButtonProps}
                      disabled={uploading}
                      style={{ display: "inline" }}
                      onClick={this.handleClick}
                    >
                      {uploading ? "Uploading..." : "Change"}
                    </Button>
                  )}

                  <Button
                    {...removeButtonProps}
                    disabled={uploading}
                    style={{ display: "inline" }}
                    onClick={this.handleRemove}
                  >
                    Remove
                  </Button>
                </span>
              )
            )}
          </div>
        </div>

        {this.state.toast && (
          <ToastModal
            toastMessage={this.state.toastMessage}
            toastMessageType={this.state.toastMessageType}
            toastUpdate={this.toastUpdate}
          />
        )}
      </>
    );
  }
}

FileUploadDocumentLinkApi.propTypes = {
  avatar: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
  supportedMimeType: PropTypes.array,
  sendFile: PropTypes.func,
  removeFile: PropTypes.func,
  noPreview: PropTypes.bool,
  apiHandler: PropTypes.func.isRequired,
  endpoint: PropTypes.object.isRequired,
  authToken: PropTypes.string.isRequired,
  loanApplicationId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  documentLinkField: PropTypes.string.isRequired,
  removeSpecialCharFileName: PropTypes.func,
  name: PropTypes.string,
  removeButton: PropTypes.bool,
  buttonClass: PropTypes.bool,
  localClasses: PropTypes.object,
  icon: PropTypes.bool,
};

export default withStyles(styles)(FileUploadDocumentLinkApi);